import BackgroundImg from "../assets/JoinOurNetwork.png";
import BlogDetailsImgOne from "../assets/images/Home/BlogOne.jpg";

// About
export const EmpoweredQuoteStyles = {
  EmpoweredQuoteContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    py: 4,
  },
  DividerBar: {
    height: 1.5,
    // flex: 1,
    background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
    mr: 2, // 2
    borderRadius: 4,
    width: "250px",
  },
  BelieveDescpTxt: {
    fontFamily: "'Poppins', sans-serif",
    fontStyle: "italic",
    fontSize: "1.2rem",
    color: "#1e3a8a",
    textAlign: "center",
    maxWidth: 700,
  },
  BelieveDescpTxtNew: {
    fontFamily: "'Poppins', sans-serif",
    fontStyle: "italic",
    // fontSize: "1.2rem",
    fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
    color: "#1e3a8a",
    textAlign: "center",
    maxWidth: 700,
  },
};
export const FlipCardStyles = {
  BoxMainContainer: {
    perspective: 1000,
    height: 290,
    p: 0.3,
    borderRadius: 3,
    width: 250,
    gapping: 3,
    background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
    border: "2px solid cfd8dc",
  },
  BoxMainSubContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    textAlign: "center",
    transition: "transform 0.6s",
    transformStyle: "preserve-3d",
    "&:hover": {
      transform: "rotateY(180deg)",
    },
  },
  CardContainer: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backfaceVisibility: "hidden",
    borderRadius: 2,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: 3,
  },
  CardBottomSection: {
    mt: 1,
    width: "98%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: 1,
  },
  NameTxt: {
    fontFamily: '"Poppins", serif',
    fontWeight: 600,
    textAlign: "left",
    fontSize: "1.1rem",
  },
  PositionTxt: {
    fontFamily: '"Poppins", serif',
    fontSize: "0.8rem",
    mb: 1,
  },
  IconStyling: { color: "#0A66C2", fontSize: 28, cursor: "pointer" },
  BackFlipSideCardContainer: {
    position: "absolute",
    width: "87%",
    height: "89%",
    backfaceVisibility: "hidden",
    transform: "rotateY(180deg)",
    borderRadius: 2,
    boxShadow: 3,
    p: 2,
    color: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "white",
  },
};

// Hero Card
export const GlobalHeroCardStyles = {
  HeroParentCard: {
    position: "relative",
    height: "100vh",
    backgroundImage: `url(${BackgroundImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  OverLayContainer: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(90deg, rgba(0,0,80,0.6), rgba(0,0,255,0.5))",
    zIndex: 1,
  },
  TitleSubTitleTxtCard: {
    position: "relative",
    zIndex: 2,
    textAlign: "center",
  },
  JoinNetworkTxt: {
    mb: 3,
    fontWeight: 600,
    textTransform: "uppercase",
    fontFamily: '"Poppins",serif',
  },
  JoinNetworkSubHeadingTxt: {
    lineHeight: 1.8,
    fontFamily: '"Poppins",serif',
  },
};

// Home
export const BannerStyles = {
  bannerBox: {
    zIndex: "1",
    display: "flex",
    overflow: "hidden",
    height: "70vh",
    position: "relative",
    alignItems: "center",
    backgroundSize: "cover",
    justifyContent: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    marginTop: 5,
    "& .bannerText": {
      top: "43%",
      right: "19%",
      opacity: "0.3",
      maxWidth: "300px",
      position: "absolute",
    },
    "&::before": {
      top: "0px",
      left: "0px",
      width: "100%",
      height: "100%",
      content: "''",
      position: "absolute",
      background: "#fff",
    },
  },
  mainbannerBox: {
    position: "relative",
    overflow: "hidden",
    padding: "30px 35px",
    textAlign: "center",
    "& .leftShade1": {
      position: "relative",
      zIndex: "999",
      boxShadow: "39px -9px 60px 49px #000000",
    },
    "& video": {
      objectFit: "cover",
      width: "100vw",
      height: "100vh",
      position: "absolute",
      top: "0",
      left: "0",
    },
  },
  bannerTitle: {
    fontWeight: "600",
    fontSize: "2rem",
    // background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
    background: "linear-gradient(93.14deg,#1E90FF, #63B8FF)",
    WebkitBackgroundClip: "text",
    display: "inline-block",
    fontFamily: '"Poppins",serif',
    WebkitTextFillColor: "transparent",
    textTransform: "uppercase",
  },
  bannerDescription: {
    width: "70%",
    color: "grey",
    fontSize: "1rem",
    fontWeight: "400",
    alignItems: "center",
    fontFamily: '"Poppins",serif',
  },
};
export const HomeBannerStyles = {
  bannerBox: {
    zIndex: "1",
    display: "flex",
    overflow: "hidden",
    height: "70vh",
    position: "relative",
    alignItems: "center",
    backgroundSize: "cover",
    justifyContent: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    marginTop: 5,
    "& .bannerText": {
      top: "43%",
      right: "19%",
      opacity: "0.3",
      maxWidth: "300px",
      position: "absolute",
    },
    "&::before": {
      top: "0px",
      left: "0px",
      width: "100%",
      height: "100%",
      content: "''",
      position: "absolute",
      background: "#fff",
    },
  },
  mainbannerBox: {
    position: "relative",
    overflow: "hidden",
    padding: "30px 35px",
    textAlign: "center",
    "& .leftShade1": {
      position: "relative",
      zIndex: "999",
      boxShadow: "39px -9px 60px 49px #000000",
    },
    "& video": {
      objectFit: "cover",
      width: "100vw",
      height: "100vh",
      position: "absolute",
      top: "0",
      left: "0",
    },
  },
  bannerTitle: {
    fontWeight: "600",
    // fontSize: "2rem",
    // fontSize: { xs: "1.3rem", sm: "1.3rem", md: "2rem" },
    fontSize: { xs: "1.5rem", sm: "1.5rem", md: "2rem" },
    // background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
    background: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
    WebkitBackgroundClip: "text",
    display: "inline-block",
    fontFamily: '"Poppins",serif',
    WebkitTextFillColor: "transparent",
    textTransform: "uppercase",
  },
  BlckBannerTitle: {
    fontWeight: "600",
    fontSize: { xs: "1.6rem", sm: "1.6rem", md: "1.8rem" },
    // background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
    // WebkitBackgroundClip: "text",
    // display: "inline-block",
    fontFamily: '"Poppins",serif',
    // WebkitTextFillColor: "transparent",
    // textTransform: "uppercase",
  },
  bannerDescription: {
    width: "70%",
    color: "grey",
    fontSize: "1rem",
    fontWeight: "400",
    alignItems: "center",
    fontFamily: '"Poppins",serif',
    textAlign: "justify",
  },
  BannerDescriptionTwo: {
    color: "black",
    fontSize: "1rem",
    fontWeight: "400",
    alignItems: "center",
    fontFamily: '"Poppins",serif',
  },
  BannerDescriptionThree: {
    color: "black",
    fontSize: "1.4rem",
    fontWeight: "400",
    alignItems: "center",
    fontFamily: '"Poppins",serif',
  },
};
export const FastestGrowingStyles = {
  root: {
    textAlign: "center",
    // padding: "30px 35px",
    padding: "0px 35px",
  },
  title: {
    fontWeight: 700,
    fontSize: "2rem",
    background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    display: "inline-block",
    fontFamily: '"Poppins",serif',
    textTransform: "uppercase",
  },
  TitleTxtContainer: {
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  TitleTxts: {
    fontWeight: 700,
    fontSize: "2rem",
    background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    display: "inline-block",
    fontFamily: '"Poppins",serif',
    textTransform: "uppercase",
  },
  subTitleContainer: {
    textAlign: "center",
  },
  subTitle: {
    width: "70%",
    color: "grey",
    fontSize: "1rem",
    fontWeight: 400,
    fontFamily: '"Poppins",serif',
    margin: "auto",
  },
  DescriptionTxts: {
    width: "65%",
    color: "grey",
    fontSize: "1rem",
    fontWeight: 400,
    fontFamily: '"Poppins",serif',
    margin: "auto",
    textAlign: "center",
  },
  gridItem: {
    display: "flex",
    justifyContent: "center",
  },
  cardWrapper: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    justifyContent: "start",
  },
  card: {
    width: 250, // 270
    padding: "10px", // 15px
    borderRadius: "16px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(45deg, #cfd8dc, #cfd8dc) border-box",
    border: "2px solid transparent",
  },
  cardTopSection: {
    gap: 1,
    width: "100%",
    display: "flex",
    // alignItems: "center",
    // justifyContent: "space-around",
  },
  iconCircle: {
    width: 25,
    height: 25,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(45deg, #0052CC, #007FFF) border-box",
    border: "3px solid transparent",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  },
  cardTitle: {
    color: "gray",
    marginTop: "5px",
    marginLeft: "10px",
    fontSize: "1.05rem",
    fontFamily: '"Poppins", serif',
  },
  cardCount: {
    fontWeight: 600,
    // marginTop: "10px",
    fontSize: "1.5rem",
    fontFamily: '"Poppins", serif',
  },
  plusSign: {
    color: "#0052CC",
  },
  cardDescription: {
    color: "gray",
    marginTop: "5px",
    fontSize: "0.96rem",
    fontFamily: '"Poppins", serif',
  },
  bottomLine: {
    width: "40px",
    height: "2px",
    backgroundColor: "#0052CC",
    marginTop: "5px",
  },
};
export const ReImagineStyles = {
  root: {
    textAlign: "center",
    padding: "30px 0px",
  },
  rootTwo: {
    textAlign: "center",
    padding: "30px 30px",
  },
  title: {
    fontWeight: 700,
    fontSize: "2rem",
    background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
    WebkitBackgroundClip: "text",
    display: "inline-block",
    fontFamily: '"Poppins",serif',
    WebkitTextFillColor: "transparent",
    textTransform: "uppercase",
  },
  highlight: {
    color: "#0066FF",
  },
  gridItem: {
    display: "flex",
    justifyContent: "center",
  },
  iconBox: {
    width: 65,
    height: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F4F6FA",
    borderRadius: 3,
    position: "absolute",
    left: 40,
    top: -45,
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(45deg, #FF8C00, #FF4500) border-box",
    border: "3px solid transparent",
  },
  verticalLine: {
    width: 2.5,
    height: 26,
    backgroundColor: "#FF4500",
    position: "absolute",
    left: 48,
    top: 30,
  },
  horizontalLine: {
    width: 30,
    height: 2.2,
    backgroundColor: "#FF4500",
    marginTop: "5px",
  },
  card: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 20px",
    width: "100%",
    minHeight: 80,
    borderRadius: 3,
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.05)",
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(45deg, #FF8C00, #FF4500) border-box",
    border: "3px solid transparent",
    transition: "all 0.3s ease-in-out",
  },
  cardText: {
    fontSize: 16,
    fontFamily: '"Poppins", serif',
  },
};
export const ScrollCardStyles = {
  scrollContainer: {
    display: "flex",
    overflowX: "auto",
    gap: { xs: 3, sm: 2, md: 3 },
    p: { xs: 0, sm: 2, md: 3 },
    scrollbarWidth: "none", // Hide scrollbar for Firefox
    "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar for Chrome/Safari
  },

  card: {
    minWidth: 300,
    maxWidth: 500,
    // minHeight: 375,
    // minHeight: { xs: 280, sm: 2, md: 375 },
    minHeight: { xs: 220, sm: 2, md: 275 },
    border: "2px solid transparent",
    background: "white",
    backgroundClip: "padding-box",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: "inherit",
      // background: "linear-gradient(45deg, #FF8C00, #FF4500)",
      background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
      WebkitMask:
        "linear-gradient(white, white) content-box, linear-gradient(white, white)",
      mask: "linear-gradient(white, white) content-box, linear-gradient(white, white)",
      WebkitMaskComposite: "destination-out",
      maskComposite: "exclude",
      pointerEvents: "none",
    },
    "&:hover": {
      // boxShadow: 6, // Increased shadow on hover
      transform: "scale(1.015)", // Slight scaling effect
      "&::before": {
        // background: "linear-gradient(45deg, #FF4500, #FF0000)", // Stronger gradient on hover
        background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)", // Stronger gradient on hover
      },
    },
  },

  TitleTxt: {
    fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" }, // Adjusted text size
    fontWeight: 600,
    fontFamily: '"Poppins", serif',
    textAlign: "left",
  },

  SubTitleTxt: {
    fontSize: { xs: "0.85rem", sm: "1rem" },
    color: "text.secondary",
    fontFamily: '"Poppins", serif',
    fontWeight: 500,
    textAlign: "left",
  },

  underline: {
    width: "65px",
    height: "4px",
    background: "linear-gradient(45deg, #FF8C00, #FF4500)",
    WebkitMaskImage: "linear-gradient(white, white)",
    maskImage: "linear-gradient(white, white)",
    borderRadius: "2px",
    my: 1,
  },

  DescriptionTxt: {
    fontSize: { xs: "0.75rem", sm: "0.875rem", md: "0.9rem" },
    color: "text.secondary",
    fontFamily: '"Poppins", serif',
    textAlign: "justify",
    fontWeight: 400,
  },
};
export const TailoredStyles = {
  bannerBox: {
    zIndex: 1,
    display: "flex",
    overflow: "hidden",
    height: "70vh",
    position: "relative",
    alignItems: "center",
    backgroundSize: "cover",
    justifyContent: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    "& .bannerText": {
      top: "43%",
      right: "19%",
      opacity: 0.3,
      maxWidth: "300px",
      position: "absolute",
    },
    "&::before": {
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      content: "''",
      position: "absolute",
      background: "#fff",
    },
  },
  mainbannerBox: {
    position: "relative",
    overflow: "hidden",
    padding: "0px 35px",
    textAlign: "center",
    "& .leftShade1": {
      position: "relative",
      zIndex: 999,
      boxShadow: "39px -9px 60px 49px #000000",
    },
    "& video": {
      objectFit: "cover",
      width: "100vw",
      height: "100vh",
      position: "absolute",
      top: 0,
      left: 0,
    },
  },
  playNow: {},
  title: {
    fontWeight: 600,
    fontSize: "2rem",
    background: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
    WebkitBackgroundClip: "text",
    display: "inline-block",
    fontFamily: '"Poppins", serif',
    WebkitTextFillColor: "transparent",
    textTransform: "uppercase",
  },
  description: {
    width: "70%",
    color: "grey",
    fontSize: "1rem",
    fontWeight: 400,
    alignItems: "center",
    fontFamily: '"Poppins", serif',
  },

  image: {
    width: 400,
    height: 400,
    marginTop: 40,
  },
};
export const GetInTouchStyles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "2rem",
    // padding: "2rem",
    flexDirection: { md: "row" },
    justifyContent: { md: "center" },
    padding: { md: "4rem" },
    // [theme.breakpoints.up("md")]: {
    //   flexDirection: "row",
    //   justifyContent: "center",
    //   padding: "4rem",
    // },
  },
  textSection: {
    // textAlign: "center",
    maxWidth: "500px",
    textAlign: { xs: "center", md: "left" },
    // [theme.breakpoints.up("md")]: {
    //   textAlign: "left",
    // },
  },
  heading: {
    fontSize: "2rem",
    fontWeight: 600,
    marginBottom: "1rem",
    fontFamily: '"Poppins", serif',
  },
  subtext: {
    fontSize: "1rem",
    color: "#666",
    fontFamily: '"Poppins", serif',
  },
  formCard: {
    maxWidth: "500px",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
    background: "linear-gradient(to bottom, #f9f9f9, #e6ecf5)",
  },
  formHeading: {
    fontSize: "1.8rem",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "1rem",
    fontFamily: '"Poppins", serif',
  },
  highlight: {
    color: "#0056E9",
  },
  formSubtext: {
    fontSize: "0.9rem",
    color: "#777",
    textAlign: "center",
    marginBottom: "1.5rem",
    fontFamily: '"Poppins", serif',
  },
  formGrid: {
    marginBottom: "1rem",
  },
  privacyText: {
    fontSize: "0.8rem",
    color: "#777",
    textAlign: "center",
    marginTop: "1rem",
    fontFamily: '"Poppins", serif',
  },
  privacyLink: {
    color: "#0056E9",
    fontWeight: "bold",
    cursor: "pointer",
  },
  submitButton: {
    background: "#0056E9",
    color: "#fff",
    padding: "12px 24px",
    width: "100%",
    borderRadius: "8px",
    marginTop: "1.5rem",
    fontFamily: '"Poppins", serif',
    "&:hover": {
      background: "#003bb1",
    },
  },
  LabelTxt: {
    fontWeight: 500,
    fontSize: "1rem",
    mb: 1,
    fontFamily: '"Poppins", serif',
    display: "flex",
    alignItems: "center",
  },
  LabelValueTxt: {
    fontWeight: 400,
    fontSize: "0.9rem",
    // mb: 1,
    color: "#808080",
    fontFamily: '"Poppins", serif',
    mx: 1,
  },
};

// Join Our Network
export const WhatWeDoStyles = {
  HeadingTxt: {
    fontWeight: "600",
    fontSize: "2rem",
    background: "linear-gradient(93.14deg, #FF8C00, #FF4500)",
    WebkitBackgroundClip: "text",
    display: "inline-block",
    fontFamily: '"Poppins",serif',
    WebkitTextFillColor: "transparent",
    textTransform: "uppercase",
    marginTop: 30,
  },
  SubHeadingTxt: {
    width: "70%",
    color: "grey",
    fontSize: "1rem",
    fontWeight: "400",
    alignItems: "center",
    fontFamily: '"Poppins",serif',
  },
  IconBoxContainer: {
    width: 65,
    height: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F4F6FA",
    borderRadius: 3,
    // position: "absolute",
    left: 40,
    top: -45,
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    position: "relative",
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(45deg, #cfd8dc, #cfd8dc) border-box",
    border: "3px solid transparent", // Transparent border to show gradient
  },
  GridCardContainer: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    justifyContent: "start",
  },
  VerticalLineBar: {
    width: 2.5,
    height: 26,
    backgroundColor: "#cfd8dc",
    position: "absolute",
    left: 48,
    top: 30,
  },
  HorizontalLineBar: {
    width: 30,
    height: 2.2,
    backgroundColor: "#cfd8dc",
    marginTop: "5px",
  },
  TitleSubTitleTxtCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 20px",
    width: "100%", // Ensure full width inside the grid
    // maxWidth: 350, // Consistent width across all cards
    minHeight: 80,
    borderRadius: 3,
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.05)",
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(45deg, #cfd8dc, #cfd8dc) border-box",
    border: "3px solid transparent",
    transition: "all 0.3s ease-in-out",
  },
  TitleSubTitleTxt: { fontSize: 16, fontFamily: '"Poppins", serif' },
};
export const JobCardStyles = {
  JobCardMainContainer: {
    // width: 340,
    width: { xs: 300, sm: 520, md: 340 },
    // maxWidth: 340,
    p: { xs: 1.5, md: 3 },
    borderRadius: 3,
    boxShadow: 3,
    px: 7,
  },
  JobTypeTitlTxt: {
    fontWeigh: 700,
    color: "#0A2540",
    fontFamily: '"Poppins", serif',
    fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
  },
  JobLocationLabelTxt: {
    backgroundColor: "#E8F0FE",
    color: "#1A73E8",
    px: 1,
    py: 0.2,
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 0.5,
    mr: 1,
    fontFamily: '"Poppins", serif',
  },
  JobLocationValueTxt: { fontFamily: '"Poppins", serif' },
  CopyLinkBtnTxt: {
    backgroundColor: "#F0F4FF",
    color: "#1A73E8",
    textTransform: "none",
    boxShadow: "none",
    fontFamily: '"Poppins", serif',
    "&:hover": { backgroundColor: "#e0e8fc" },
    flexGrow: 1,
  },
  ShareJobTxt: { fontFamily: '"Poppins", serif' },
  CopyLibkTxt: { fontFamily: '"Poppins", serif' },
  ApplyNowButton: {
    mt: 3,
    textTransform: "none",
    fontWeight: 600,
    color: "#fff",
    // background: "linear-gradient(to right, #3C76F5, #2B64F0)",
    background: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
    borderRadius: "30px",
    py: 1.5,
    "&:hover": {
      // background: "linear-gradient(to right, #1C1D3B, #3C76F5)",
      background: "linear-gradient(93.14deg, #63B8FF, #1E90FF)",
    },
  },
};

// Blogs
export const BlogCardStyles = {
  BlogParentCardContainer: {
    borderRadius: 3,
    overflow: "visible",
    position: "relative",
    maxWidth: 350,
    // m: 2,
  },
  BlogTitle: {
    position: "absolute",
    top: -12,
    right: 16,
    backgroundColor: "#0056D2",
    color: "#fff",
    px: 2,
    py: 1,
    borderRadius: "0 6px 0 6px",
    fontSize: 12,
    fontWeight: 500,
    zIndex: 1,
    fontFamily: '"Poppins", serif',
  },
  BlogImages: {
    width: "100%",
    height: 180,
    objectFit: "cover",
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
  BlogHeadingTxt: { fontWeight: 600, fontFamily: '"Poppins", serif' },
  BlogDescriptionTxt: {
    mb: 2,
    height: 120,
    overflow: "hidden",
    fontFamily: '"Poppins", serif',
  },
  BlogCreatedDateTxt: {
    fontWeight: 500,
    color: "#0056D2",
    fontFamily: '"Poppins", serif',
  },
};

// Blog Details Page Styling
export const BlogDetailsStyles = {
  HeroParentCard: {
    position: "relative",
    height: "90vh",
    backgroundImage: `url(${BlogDetailsImgOne})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
};

// Commom Styling
export const CommonStyles = {
  root: {
    textAlign: "center",
    // padding: "30px 35px",
    padding: "0px 0px",
  },
  ParentRootContainer: {
    marginTop: 10,
    padding: "30px 30px",
  },
};
